export interface CalendarEvent {
  name: string
  date: Date,
}

export enum CalendarFormat {
  month = 'month',
  twoWeeks = 'twoWeeks',
  week = 'week'
}

export type OnVisibleDaysChanged = (
  first: Date,
  last: Date,
  format: CalendarFormat
) => void


export interface UseCalendarParams {
  events?: CalendarEvent[]
  holidays?: Event[]
  initialDay?: Date
  initialFormat?: CalendarFormat
  availableCalendarFormats?: CalendarFormat[]
  startingDayOfWeek?: DaysOfWeek
  selectedDayCallback?: (selectedDate: Date) => void
  onVisibleDaysChanged?: OnVisibleDaysChanged
  onCalendarCreated?: (
    firstDay: Date,
    lastDay: Date,
    calendarFormat: CalendarFormat
  ) => void
  includeInvisibleDays?: boolean
  weekendDays?: string[]
}

export enum DaysOfWeek {
  sunday,
  monday,
  tuesday,
  wednesday,
  thursday,
  friday,
  saturday
}
